import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { useMap } from 'react-leaflet'
import Leaflet from 'leaflet'

import { heatmapDataSelector, hasHeatmapDataSelector, heatmapIdSelector } from '../../../../../store/heatmap/selectors'

export const CenteringControls: React.FC = () => {
  const map = useMap()
  const data = useSelector(heatmapDataSelector)
  const hasData = useSelector(hasHeatmapDataSelector)
  const currentMapId = useSelector(heatmapIdSelector)
  const prevHeatmapValuesRef = useRef({ currentMapId, hasData })

  useEffect(() => {
    if (!data || !hasData) {
      return
    }

    // Only reset the map when the id changes. If data is unchanged and map renders, dont change bounds
    if (
      currentMapId !== prevHeatmapValuesRef.current.currentMapId ||
      hasData !== prevHeatmapValuesRef.current.hasData
    ) {
      const geoJsonLayer = Leaflet.geoJSON(data)
      const geoJsonBounds = geoJsonLayer.getBounds()

      map.fitBounds(geoJsonBounds)
      prevHeatmapValuesRef.current = {
        currentMapId,
        hasData
      }
    }
  }, [data, hasData])

  return null
}
